module.exports = __webpack_public_path__ + "img/image-9.aa3d1d52.webp";